
import { useBusyState } from 'apprise-frontend-core/utils/busyguard';
import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard';
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { useLanguage } from './language';
import { useIntl } from './state';
import { IntlProps } from 'apprise-frontend-core/intl/intl';



export const IntlLoader = (props: IntlProps) => {

    const { children, translations = {} } = props

    const resources = Object.entries(translations).reduce((acc, [lang, content]) => ({ ...acc, [lang]: { translation: content } }), {})

    const lang = useLanguage()

    const intl = useIntl()

    // if available, we use the busy-wait system to fetch translations.
    const busy = useBusyState()

    const activate = async () => {

        var error: any = undefined;

        return busy.toggle("translations")
            .then(() =>

                i18next
                    .use(initReactI18next) // passes i18n down to react-i18next
                    .init({

                        // i18next 21 defaults to JSON v4 plurals (key_one / key_other). our
                        // locales are v3 (key_plural), and the FR half is the translators' to
                        // change, not ours.
                        compatibilityJSON: 'v3',

                        partialBundledLanguages: true,

                        returnEmptyString: false,
                       
                        fallbackLng: lang.default(),
                        react: {
                            useSuspense: false
                        },

                        debug: false,
                        nsSeparator: "::",
                        resources,
                        interpolation: {

                            escapeValue: false,
                            format: function (value, format) {
                                if (format === 'uc') return value.toUpperCase();
                                if (format === 'lc') return value.toLowerCase();
                                return value;
                            }

                        } // react already safe from XSS

                    },
                        //  throwing errors from here won't propagae to thenables (must be caught)
                        //  so we track the error manually and throw from the first thenable.
                        e => { if (e) error = new Error(e) }

                    ))

            .then(() => { if (error) throw error })

            .then(() => intl.register(i18next.t.bind(i18next), i18next.changeLanguage.bind(i18next)))

            .finally(() => busy.toggle("translations"))

    }

    // initialises i18next before rendering children.

    const { content } = useRenderGuard({

        render: children,

        orRun: activate

    })

    return content
}
